import React, { useState } from 'react';
import { DataTable, KPI, KPIRow, Loading, Msg, Section, Select, useAdminGet } from '../kit';

/** For You · Usage: who uses the page, what they ask for, what they share. */

const S = 'foryou';

const ForYouUsage: React.FC = () => {
  const [days, setDays] = useState('30');
  const res = useAdminGet<any>(S, 'usage', { days }, [days]);
  if (res.loading && !res.data) return <Loading />;
  if (res.error) return <Msg kind="error">{res.error}</Msg>;
  const d = res.data || {};
  const k = d.kpis || {};
  const n = (v: any) => Number(v || 0).toLocaleString();
  return (
    <div className="flex flex-col gap-4">
      <KPIRow>
        <KPI label="Members with a problem statement" value={n(k.members_with_problem_profile)}
             hint={`${n(k.members_with_problem)} on For You · ${n(k.problems)} statements`} />
        <KPI label="Members with a keyword" value={n(k.members_with_keyword)} hint={`${n(k.keywords_distinct)} distinct keywords`} />
        <KPI label="Members who opened For You" value={n(k.members_visited)} />
        <KPI label="Shares sent" value={n(k.shares_sent)} hint={`${n(k.techs_shared)} technologies · ${n(k.shares_failed)} failed`} />
        <KPI label="Recipients" value={n(k.recipients)} hint={`${n(k.copies)} copied messages`} />
        <KPI label={`Featured clicks (${d.days}d)`} value={n(k.featured_clicks)} hint={`${n(k.rec_opens)} recommendation opens`} />
      </KPIRow>

      <Section title="Page events" right={
        <Select value={days} onChange={setDays} options={['7', '30', '90', '365']}
                labels={{ '7': 'Last 7 days', '30': 'Last 30 days', '90': 'Last 90 days', '365': 'Last year' }} />}>
        <DataTable rows={d.events || []} columns={['action', 'events', 'people']} csvName="foryou_events"
                   empty="No For You events in this period." defaultSort="-events" />
      </Section>

      <Section title="Problem statements in use">
        <DataTable rows={d.problems || []} columns={['text', 'members', 'matches', 'status', 'matched_at', 'emails']}
                   labels={{ text: 'Statement', matched_at: 'Matched' }} searchable csvName="foryou_problems"
                   empty="No statements yet." defaultSort="-members" />
      </Section>

      <Section title="Keywords in use">
        <DataTable rows={d.keywords || []} columns={['keyword', 'members', 'pool_status', 'pool_size', 'pool_built_at']}
                   labels={{ pool_built_at: 'Pool built' }} searchable csvName="foryou_keywords"
                   empty="No keywords yet." defaultSort="-members" />
      </Section>

      <Section title="Recent shares">
        <DataTable rows={d.shares || []} columns={['created_at', 'member', 'channel', 'recipients', 'techs', 'sent_ok', 'error']}
                   labels={{ created_at: 'When', sent_ok: 'Sent' }} searchable csvName="foryou_shares"
                   empty="No shares yet." />
      </Section>
    </div>
  );
};

export default ForYouUsage;
